module.exports = __webpack_public_path__ + "static/tuv-c345357bc1f758326938d7243599c701.jpg";